import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_edit_flagging_search_btn = _resolveComponent("edit-flagging-search-btn")!
  const _component_client_posts_toolbar = _resolveComponent("client-posts-toolbar")!

  return (_openBlock(), _createBlock(_component_client_posts_toolbar, {
    client: _ctx.client,
    filters: _ctx.filters,
    minimized: _ctx.minimized,
    "maximize-btn": _ctx.maximizeBtn,
    "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:filters', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_edit_flagging_search_btn, {
        "client-id": _ctx.client.id,
        icon: "fa fa-flag",
        label: "Add Flags",
        rounded: ""
      }, null, 8, ["client-id"])
    ]),
    _: 1
  }, 8, ["client", "filters", "minimized", "maximize-btn"]))
}